import usePagination from '@/hooks/usePagination';
import { OrderEnum } from '@/types/schema';

import { useGetContentVersionsQuery } from './graphql/queries/generated/getContentVersions';

const useVersionHistory = (contentId: string) => {
  const { data, fetchMore, isFetching } = usePagination(
    useGetContentVersionsQuery,
    {
      filters: {
        contentId,
      },
      sort: {
        field: 'createdAt',
        order: OrderEnum.Desc,
      },
    },
    {
      edgeKey: 'contentVersions',
    },
  );

  return {
    versionsHistory: data,
    fetchMore,
    initialFetching: isFetching,
  };
};

export default useVersionHistory;
